import { useEffect, useState } from 'react';
import { browserCapabilities } from './http';

export function useBrowserCapabilities(): boolean {
  const [supported, setSupported] = useState(true);
  useEffect(() => {
    try {
      browserCapabilities();
    } catch {
      setSupported(false);
    }
  }, []);
  return supported;
}
